var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"icon":"mdi-printer","title":"PDF"},on:{"click":_vm.download}})
}
var staticRenderFns = []

export { render, staticRenderFns }